import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonButtons, IonHeader, IonIcon, IonMenuToggle, NavController } from '@ionic/angular';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RoutingSegment } from '../../entities/routing-segment';
import { ToolbarService } from '../../services/toolbar/toolbar.service';
import { ConfigService } from '../../../config/services/config.service';
import { CurafidaAuthService } from '../../../authentication/curafida-auth.service';
import { StyleService } from '../../services/style/style.service';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'toolbar-patient',
    templateUrl: './toolbar-patient.component.html',
    styleUrls: ['./toolbar-patient.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, IonHeader, IonMenuToggle, IonButtons],
})
export class ToolbarPatientComponent {
    readonly authService = inject(CurafidaAuthService);
    readonly configService = inject(ConfigService);
    readonly toolbarService = inject(ToolbarService);
    private readonly navCtrl = inject(NavController);
    protected tab: string;

    constructor(readonly router: Router) {
        this.initToolbar();
    }

    openProfile(): void {
        this.router.navigate([RoutingSegment.MEMBER, RoutingSegment.PROFILE]);
    }

    protected backToHome() {
        const isLoggedIn = Boolean(this.authService.loggedInUser());
        if (!isLoggedIn) {
            if (this.router.url.includes('shop')) {
                this.navCtrl.navigateBack(['shop', 'main']);
                return;
            }
            if (this.router.url.includes('register')) {
                return;
            }
        }
        if (this.router.url.includes('article') || this.router.url.includes('program')) {
            this.router.navigate(['member', 'patient', 'home'], {
                queryParams: { home: 'shop', shop: null, program: null, article: null },
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
        } else {
            this.router.navigate(['member', 'patient', 'home'], {
                queryParams: { home: this.tab },
                queryParamsHandling: 'merge',
            });
        }
    }

    private async initToolbar() {
        const appConfig = this.configService.frontendConfig();
        const backendFeatures = this.configService.config()?.configuration?.features;
        if (backendFeatures?.user?.patient?.planer.enabled) {
            this.tab = 'journal';
        } else if (backendFeatures?.user?.patient?.statistics.enabled) {
            this.tab = 'chart';
        } else if (backendFeatures?.chat?.enabled) {
            this.tab = 'chat';
        } else if (backendFeatures?.announcement?.enabled) {
            this.tab = 'announcement';
        } else if (backendFeatures?.catalog?.enabled) {
            this.tab = 'shop';
        }
    }
}
